function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "vuesax/bulk/sms"
}, React.createElement("g", {
  id: "sms"
}, React.createElement("path", {
  id: "Vector",
  d: "M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z",
  fill: "#507FC8"
}), React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  id: "Vector_2",
  d: "M11.9998 12.87C11.1598 12.87 10.3098 12.61 9.65978 12.08L6.52978 9.58C6.20978 9.32 6.14978 8.85 6.40978 8.53C6.66978 8.21 7.13978 8.15 7.45978 8.41L10.5898 10.91C11.3498 11.52 12.6398 11.52 13.3998 10.91L16.5298 8.41C16.8498 8.15 17.3298 8.2 17.5798 8.53C17.8398 8.85 17.7898 9.33 17.4598 9.58L14.3298 12.08C13.6898 12.61 12.8398 12.87 11.9998 12.87Z",
  fill: "#F264D4"
}))));

var SvgCallEmailIcon = function SvgCallEmailIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCallEmailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Call_Email_Icon.6f9a6e7f.svg";
export { ForwardRef as ReactComponent };